import { styled } from "@pigment-css/react";

/** Scrolling page shell for the field-sales-2 tabs: a vertical stack with the shared
 *  page rhythm (12px between sections, 8px top, bottom clearance for the fixed nav). */
export const ScrollPage = styled("main")(({ theme }) => ({
  flex: 1,
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: theme.fieldSalesTwo.spacing[12],
  paddingTop: theme.fieldSalesTwo.spacing[8],
  // Reserve clearance so the last card scrolls clear of the fixed bottom nav.
  paddingBottom: "var(--bottom-nav-opaque-height, 0px)",
}));

/** Centered display-font section title (e.g. "Kunden im Fokus"), spaced for ScrollPage:
 *  its 12px stack gap already sits above and below, so the margins add the remainder to
 *  reach 60px above / 24px below. */
export const ScrollPageTitle = styled("h2")(({ theme }) => ({
  margin: `${theme.fieldSalesTwo.spacing[48]} ${theme.fieldSalesTwo.spacing[12]} ${theme.fieldSalesTwo.spacing[12]}`,
  textAlign: "center",
  fontFamily: theme.fieldSalesTwo.font.familySecondary,
  fontSize: theme.fieldSalesTwo.font.size[24],
  fontWeight: theme.fieldSalesTwo.font.weight[500],
  lineHeight: theme.fieldSalesTwo.font.lineHeight[125],
  color: theme.fieldSalesTwo.colors.neutral[900],
}));
